import React, { TextareaHTMLAttributes } from 'react'

import styled from 'styled-components'

import LabelledField from 'components/LabelledField'

type Props = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label: string,
  isRequired?: boolean,
  errorMessage?: string,
  className?: string
}
const Textarea = ({ label, isRequired = false, errorMessage = '', className = '', ...inputProps }: Props) => {
  const id = label.replace(' ', '_')

  return (
    <S.LabelledField {...{ id, label, isRequired, errorMessage, className }}>
      <S.Textarea {...{ id, ...inputProps }} />
    </S.LabelledField>
  )
}

export default Textarea

const S = {
  LabelledField: styled(LabelledField)`
    height: 6.5em;
  `,
  Textarea: styled.textarea`
    height: 100%;
    margin-top: 3px;
    resize: vertical;
    width: 100%;
    border-radius: 4px;
    box-shadow: none;
    resize: none;
  `
}
